<ng-container style="width:100%;height:100%">
  <app-header-nav-bar>
    <app-header-nav-snap-output [isAddClientDetails]="true" [snapNameNavHeader]="snapshotName"
        [ImageURL]="ImageURL" (defaultPanelChange)="onDefaultPanelChange($event)"></app-header-nav-snap-output>
    <app-header-section-list [clientSnapDetails]="clientDetails.clientDetails"></app-header-section-list>
    <app-header-home [moduleName]="'customsnapshot'" [additionalCheck]="additionalList" [exportReportInput]="exportReportInput"
    (OnSettingsSel)="OnSettingsSel($event)" (documentRepoClick)="handleDocumentRepo()" [hasDocuments]="hasDocuments" [isHelpGuide]="isHelpGuide"></app-header-home>
</app-header-nav-bar>

 <app-ai-alert [showAlert]="showAiAlert"></app-ai-alert>
 <app-ai-alert [showAlert]="showNegativeValuesAlert" [message]="negativeValuesAlertMessage" [showIcon]="false"></app-ai-alert>

  <!-- *ngIf="!isCreateCustomGroup" -->
  <div class="leftPanelandOutputArea" >
    <!-- <div class="leftpanel-view " style="background-color: lightgray;">
            <app-custom-leftpanel class="expandLeftPanel"></app-custom-leftpanel>
        </div> -->
    <!-- <app-leftpanel-snapshot class="expandLeftPanel" [onItemClick]="handleCheckboxClick" [moduleLists]="moduleList"
            (showOutput)="ShowOutput()" (snapNameNavHeader)="snapHeaderNameFun($event)"
            (BindImageURL)="brandLogo($event)" (valueChange)="toggleLeftPanel($event)"
            (selectedType)="selectedTypeFun2($event)" (baseValuesChanged)="onBaseValuesChanged($event)"
            (isLoadSelection)="LoadSelection($event)" [selectedScenarioData]="selectedScenarioData"
            [dataArray]="dataArray" [output_data]="output_data" [isSavedScenarioSelected]="isSavedScenarioSelected"
            (additionalList)="additionalCheck($event)" [isCustomSnapshot]="true"
            (additionalFeatures)="additionalFeatures($event)" (customvariable)="customvariable($event)"
            (dataListChange) = "dataListChange($event)"></app-leftpanel-snapshot> -->

    <!-- <app-leftpanelnewdesign style="width:100%"  [handleCheckboxClick]="handleCheckboxClick" [moduleList]="moduleList"
        [selectedScenarioData]="selectedScenarioData" [isCustomSnapshot]="true"
            [dataArray]="dataArray" [output_data]="output_data" [isSavedScenarioSelected]="isSavedScenarioSelected"
            (showOutput)="ShowOutput()"   (snapNameNavHeader)="snapHeaderNameFun($event)"  (selectedType)="selectedTypeFun2($event)" (baseValuesChanged)="onBaseValuesChanged($event)"
            (dataListChange) = "dataListChange($event)" (isLoadSelection)="LoadSelection($event)"
        >

        </app-leftpanelnewdesign> -->

        <!-- [style]="!showLeftPanel?'display:none':'display:flex'" -->

    <div class="leftpanel-parent" [class.visible]="showLeftPanel"  >
      <div #leftPanel class="leftpanelmaincontents" [ngClass]="showLeftPanel ? 'open' : 'closed'" [style]="isCreateCustomGroup?'width:100% !important':''">
        <div class="sections">
          <div class="section-components">
            <div class="subcomponent typography" (click)="sectionSelected('filter')"
              [ngClass]="isfilterSelected?'sectionSelected':'sectionNotSelected'">
              <div class="filter-icon" [ngClass]="isfilterSelected?'filter-icon-active':'filter-icon-notactive'"></div>
              <div class="component-name">Filters</div>
            </div>
            <div class="subcomponent typography" (click)="sectionSelected('savedSelection')"
              [ngClass]="isSavedSelectionSelected?'sectionSelected':'sectionNotSelected'">
              <div class="saved-selection-icon"
                [ngClass]="isSavedSelectionSelected?'saved-selection-icon-active':'saved-selection-icon-notactive'">
              </div>
              <div class="component-name">Saved Selections</div>
            </div>
            <div class="subcomponent typography" (click)="sectionSelected('features')"
              [ngClass]="isFeaturesSelected?'sectionSelected':'sectionNotSelected'">
              <div class="feature-icon" [ngClass]="isFeaturesSelected?'feature-icon-active':'feature-icon-notactive'">
              </div>
              <div class="component-name">Features</div>
            </div>
          </div>
          <div class="close-icon" (click)="toggleLeftPanel()"></div>
        </div>
        <!-- [hidden]="!isfilterSelected" -->
         <!-- (selectedConfig)="handleConfig($event)" -->
        <div class="filter-component"  [style]="!isfilterSelected?'height:0%;width:0%;opacity:0;visibility:hidden':'height:100%;width:100%'">
          <div  [style]="!isfilterSelected?'width:0%;opacity:0;visibility:hidden':'width:100%'" class="leftpanel">
            <app-leftpanel-snapshot class="expandLeftPanel" [style]="!isfilterSelected?'width:0rem;opacity:0;visibility:hidden;':'width:13rem;opacity:1'" [onItemClick]="handleCheckboxClick"
              [moduleLists]="moduleList" (showOutput)="ShowOutput()" (snapNameNavHeader)="snapHeaderNameFun($event)"
              (BindImageURL)="brandLogo($event)" (valueChange)="toggleLeftPanel($event)"
              (selectedType)="selectedTypeFun2($event)" (baseValuesChanged)="onBaseValuesChanged($event)"
              (isLoadSelection)="LoadSelection($event)" [selectedScenarioData]="selectedScenarioData"
              [dataArray]="dataArray" [output_data]="output_data" [isSavedScenarioSelected]="isSavedScenarioSelected"
              (additionalList)="additionalCheck($event)" [isCustomSnapshot]="true"
              (additionalFeatures)="additionalFeatures($event)" (IsEntrypointSelected)="IsEntrypointSelected($event)" (customContentEnabled)="onCustomContentEnabled($event)" (customvariable)="customvariable($event)"
              (dataListChange)="dataListChange($event)" (issubmitReset)="submitReset($event)"
              (snapshotselected)="snapshotselected" (sectionselected)="sectionselected" (subsectionselected)="subsectionselected"
              (increaseLeftpanelHeight)="increaseLeftpanelWidth($event)" [isAcrossdropDown]="isAcrossdropDown"
              [isGlobalDefaultSelectionEnabled] ="isGlobalDefaultSelected" [selectedBrandFromConfig]="selectedBrandFromConfig"
              ></app-leftpanel-snapshot>
          </div>
          <div *ngIf="isfilterSelected" class="submit-reset">
            <div class="btn btn-typography" [class.disabled]="!isSubmitReset" [ngClass]="isSubmitReset?'btn-active':'btn-notactive'"
              (click)="SubmitClicked()">Submit</div>
            <div class="btn btn-typography" [class.disabled]="!isSubmitReset" [ngClass]="isSubmitReset?'btn-active':'btn-notactive'"
              (click)="ResetClicked()">Reset</div>
          </div>
        </div>
        <div class="infoMessage" *ngIf="displayTable">
          <div class="infoBackButton config-btn CP" (click)="bindBackClickEvent()">
            Back
          </div>
          <div class="infoText" [innerHTML]="infoMessage"></div>
        </div>

        <!-- *ngIf="isSavedSelectionSelected && !displayTable" -->
        <div class="selection-component " [style]="!(isSavedSelectionSelected && !displayTable)?'width:0%;opacity:0;visibility:hidden;height:0%;padding:0rem':'width:100%;opacity:1'" >

          <div class="toggle_user" *ngIf="this._configService.globalDefaultSelectionFlag">
            <p>Global Default Selection</p>
            <div class="wrap_toggle">
              <div class="sigIndexArea">
                <div class="sigArea">
                    <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                        [ngClass]="{'initialSelected': isGlobalDefaultSelected}"
                        (click)="onGlobalDefaultChange(true)">
                        <span style="width:100%; display:block; text-align:center; font-size:0.75rem;line-height: 1.5rem;" class="btn-text">On</span>
                     </div>
                </div>
                <div class="indexArea">
                    <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                    [ngClass]="{'initialSelected': !isGlobalDefaultSelected}"
                        (click)="onGlobalDefaultChange(false)">
                    <span style="width:100%; display:block; text-align:center; font-size:0.75rem;line-height: 1.5rem;" class="btn-text">Off</span>
                    </div>
                </div>
            </div>
          </div>
          <hr/>
          </div>

          <div class="loadSelectionTable" [style]="!isSavedSelectionSelected?'width:0%;opacity:0.5;visibility:hidden;height:0%':'width:100%;opacity:1'">
            <div class="header-block list-container-options">
              <div class="header-arrow-block">
                <div class="list-container-text" (click)="toggleSaveSelectionList('userDefined')"> USER DEFINED
                  <div class="EntryIcon">
                    <div class="Icon EntryIconImage"></div>
                  </div>
                </div>

                <div class="search-block" title="Search"
                  *ngIf="isUserDefinedListVisible && loadUserDefinedSavedScenarioData.length>0">
                  <input type="text" [(ngModel)]="userDefinedSelectionQuery" class="search-input" placeholder="Search">
                  <div class="search-icon"></div>
                </div>
                <!-- <div class="arrow" (click)="toggleSaveSelectionList('userDefined')">
                            <div class="arrowToggle arrowToggleIcon" [ngClass]="{'arrowCollapsedIcon': isUserDefinedListVisible}">
                            </div>
                          </div> -->
              </div>

            </div>
            <div class="list-container-options" *ngIf="isUserDefinedListVisible">
              <div class="custom-table-container">

                <!-- <table class="custom-table" *ngIf="displayTable"> -->
                <table class="custom-table">
                  <thead *ngIf="loadUserDefinedSavedScenarioData.length>0">
                    <tr>
                      <ng-container *ngFor="let col of columnConfig; trackBy: trackByName">
                        <ng-container *ngIf="isChangeOfEntryPointConfigured">
                          <th [style.width]="col.userDefined_width"
                              [class.disabled-header]="isGlobalDefaultSelected && col.name === 'Set as Default'">
                            {{ col.name }}
                          </th>
                        </ng-container>
                        <ng-container *ngIf="col.name !== 'Change Entry Point' && (!isChangeOfEntryPointConfigured)">
                          <th [style.width]="col.userDefined_width_change"
                              [class.disabled-header]="isGlobalDefaultSelected && col.name === 'Set as Default'">
                            {{ col.name }}
                          </th>
                        </ng-container>
                      </ng-container>

                    </tr>
                  </thead>
                  <tbody class="custom-load-table-body">
                    <tr [ngClass]="{'scenarioSelected': row.is_default}"
                      *ngFor="let row of loadUserDefinedSavedScenarioData| search: userDefinedSelectionQuery : ['selection_name']; trackBy: trackBySelectionName">
                      <td [style.width]="isChangeOfEntryPointConfigured? '50%':'80%'"
                        [title]="row.is_shared || row.shared_details?.length > 0 ? row.selection_name + '_Shared' : row.selection_name"
                        [ngClass]="{'ellipsis-cell': isChangeOfEntryPointConfigured,'ellipsis-cell-noentry': !isChangeOfEntryPointConfigured }">
                        <div class="scenarioName">
                          <!-- <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.is_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'userDefined')"> 
                            {{ row.snapshotType }} | {{ row.section }}
                            {{ row.subSection && row.subSection !== 'NA' ? ' | ' + row.subSection : '' }} |-->
                            {{ row.selection_name }}{{ row.is_shared || row.shared_details?.length > 0 ? '_Shared' : '' }}
                        </div>
                      </td>

                      <ng-container *ngIf="isChangeOfEntryPointConfigured">
                        <td [style.width]="'12%'" class="imageContainer CP ">
                          <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.is_default" [disabled]="isGlobalDefaultSelected"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'userDefined')">
                        </td>
                        <td [style.width]="'10%'" class="imageContainer CP LoadImageActive"

                          (click)="handleLoadOptionsClick('load', row,'userDefined')"></td>
                        <td [style.width]="'10%'" class="imageContainer CP InfoImageActive"

                          (click)="handleLoadOptionsClick('info', row,'userDefined')"></td>
                        <td [style.width]="'10%'" class="imageContainer CP DeleteImageActive"

                          (click)="handleLoadOptionsClick('delete', row,'userDefined')"></td>

                        <!-- <td [style.width]="'14%'" class="imageContainer CP changeEntryPointImage"
                                    (click)="handleLoadOptionsClick('changeentrypoint', row,'userDefined')"></td> -->

                        <td [style.width]="'10%'" class="imageContainer CP ShareImageActive"

                          (click)="handleLoadOptionsClick('Share', row,'userDefined')"></td>

                      </ng-container>

                      <ng-container *ngIf="!isChangeOfEntryPointConfigured ">
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'LoadImageActive':'LoadImageInactive'"
                          (click)="handleLoadOptionsClick('load', row,'userDefined')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'InfoImageActive':'InfoImageInactive'"
                          (click)="handleLoadOptionsClick('info', row,'userDefined')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'DeleteImageActive':'DeleteImageInactive'"
                          (click)="handleLoadOptionsClick('delete', row,'userDefined')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.is_default?'ShareImageActive':'ShareImageInactive'"
                          (click)="handleLoadOptionsClick('Share', row,'userDefined')"></td>
                      </ng-container>



                    </tr>
                    <tr class="no-data" *ngIf="loadUserDefinedSavedScenarioData.length==0">
                      You have not created any saved selections.
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="header-block list-container-options">
              <div class="header-arrow-block">
                <div class="list-container-text" (click)="toggleSaveSelectionList('Shared With Me')"> SHARED WITH ME
                  <div class="EntryIcon">
                    <div class="Icon EntryIconImage"></div>
                  </div>
                </div>

                <div class="search-block" title="Search"
                  *ngIf="isSharedWithMeListVisible && loadSharedWithMeSavedScenarioData.length>0">
                  <input type="text" [(ngModel)]="sharedWithMeSelectionQuery" class="search-input" placeholder="Search">
                  <div class="search-icon"></div>
                </div>
                <!-- <div class="arrow" (click)="toggleSaveSelectionList('Shared With Me')">
                            <div class="arrowToggle arrowToggleIcon" [ngClass]="{'arrowCollapsedIcon': isSharedWithMeListVisible}">
                            </div>
                          </div> -->
              </div>

            </div>
            <div class="list-container-options" *ngIf="isSharedWithMeListVisible">
              <div class="custom-table-container">

                <!-- <table class="custom-table" *ngIf="displayTable"> -->
                <table class="custom-table">
                  <thead *ngIf="loadSharedWithMeSavedScenarioData.length>0">
                    <tr>
                      <!--<th *ngFor="let col of columnConfig.slice(0, -1)" [style.width]="col.sharedWithMe_width">
                                  {{ col.name }}
                                </th>-->

                      <ng-container *ngFor="let col of columnConfig.slice(0, -1); trackBy: trackByName">
                        <ng-container *ngIf="isChangeOfEntryPointConfigured">
                          <th [style.width]="col.sharedWithMe_width"
                            [class.disabled-header]="isGlobalDefaultSelected && col.name === 'Set as Default'">
                            {{ col.name }}
                          </th>
                        </ng-container>
                        <ng-container *ngIf="col.name !== 'Change Entry Point' && (!isChangeOfEntryPointConfigured)">
                          <th [style.width]="col.sharedWithMe_width_change"
                          [class.disabled-header]="isGlobalDefaultSelected && col.name === 'Set as Default'">
                            {{ col.name }}
                          </th>
                        </ng-container>
                      </ng-container>
                      <th style="width: 30%;">
                        Email
                      </th>
                    </tr>
                  </thead>
                  <tbody class="custom-load-table-body">
                    <tr [ngClass]="{'scenarioSelected': row.shared_details[0].is_Shared_default}"
                      *ngFor="let row of loadSharedWithMeSavedScenarioData | search: sharedWithMeSelectionQuery : ['selection_name','user_name']; trackBy: trackBySelectionName">
                      <td [style.width]="isChangeOfEntryPointConfigured? '40%' : '55%'"
                        [attr.title]="row.selection_name"
                        [ngClass]="{'ellipsis-cell-shared': isChangeOfEntryPointConfigured,'ellipsis-cell-shared-noentry': !isChangeOfEntryPointConfigured }">
                        <div class="scenarioName">
                          <!-- <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.shared_details[0].is_Shared_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'Shared With Me')"> -->
                          <!-- {{ row.selection_name }} -->

                            {{ row.snapshotType }} | {{ row.section }}
                            {{ row.subSection && row.subSection !== 'NA' ? ' | ' + row.subSection : '' }} |
                            {{ row.selection_name }}
                        </div>
                      </td>
                      <ng-container *ngIf="isChangeOfEntryPointConfigured">
                        <td [style.width]="'13%'" class="imageContainer CP ">
                          <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [disabled]="isGlobalDefaultSelected" [checked]="row.shared_details[0].is_Shared_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'Shared With Me')">
                        </td>
                        <td [style.width]="'10%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'LoadImageActive':'LoadImageInactive'"
                          (click)="handleLoadOptionsClick('load', row,'Shared With Me')"></td>
                        <td [style.width]="'10%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'InfoImageActive':'InfoImageInactive'"
                          (click)="handleLoadOptionsClick('info', row,'Shared With Me')"></td>

                        <td [style.width]="'10%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'DeleteImageActive':'DeleteImageInactive'"
                          (click)="handleLoadOptionsClick('delete', row,'Shared With Me')"></td>

                      </ng-container>

                      <ng-container *ngIf="!isChangeOfEntryPointConfigured">
                        <td [style.width]="'13%'" class="imageContainer CP ">
                          <input type="radio" style="margin-right: 1em;" name="{{row.selection_name}}"
                            value="{{row.selection_name}}" [checked]="row.shared_details[0].is_Shared_default"
                            (click)="selectDefaultLoadOption($event,row.selection_name,row,'Shared With Me')">
                        </td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'LoadImageActive':'LoadImageInactive'"
                          (click)="handleLoadOptionsClick('load', row,'Shared With Me')"></td>
                        <td [style.width]="'5%'" class="imageContainer CP "
                          [ngClass]="row.shared_details[0].is_Shared_default?'InfoImageActive':'InfoImageInactive'"
                          (click)="handleLoadOptionsClick('info', row,'Shared With Me')"></td>

                        <td [style.width]="'5%'" class="imageContainer CP  "
                          [ngClass]="row.shared_details[0].is_Shared_default?'DeleteImageActive':'DeleteImageInactive'"
                          (click)="handleLoadOptionsClick('delete', row,'Shared With Me')"></td>


                      </ng-container>
                      <td style="width: 30%;" title="{{row.user_name}}">
                        <div class="scenarioName">{{ row.user_name }}</div>
                      </td>

                    </tr>
                    <tr class="no-data" *ngIf="loadSharedWithMeSavedScenarioData.length==0">
                      No saved selections have been shared with you.
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="loadSelectionNoteDiv">
            <span>Note: </span>Clicking on Radio Button will make the selection your Default Selection within a Snapshot view.
            Only one selection from either User Defined or Shared with Me can be set as Default Selection</div>
        </div>
        <!-- *ngIf="isFeaturesSelected" -->
        <div class="features-component"  [style]="!(isFeaturesSelected )?'width:0%;opacity:0;visibility:hidden;height:0%;padding:0rem':'width:100%;opacity:1'">
          <div class="features-sections">
            <div class="section-names" [ngClass]="{'section-names-selected':isCustomReport}"
              (click)="onFeaturesSectionClick('customReport')">Custom Reports</div>
            <div class="section-names" [ngClass]="{'section-names-selected':isCustomVariable}"
              (mouseover)="showCustomVariable = true" (mouseleave)="showCustomVariable = false">
                  <div [ngClass]="{ itemDisable: !isCustomVariableEnabled}"
                  (click)="onFeaturesSectionClick('customVariable')">Custom Variable</div>
                  <div class="tooltip-cutom-variable"
                  *ngIf="showCustomVariable && !isCustomVariableEnabled">
                  <ul>
                    <ng-container>
                      <li *ngIf="!IsEntrypoint">Custom Variable will be enabled after selection of Entry Points</li>
                      <li *ngIf="!isCustomContentEnabled">Custom Variable will be enabled when Custom Percentage or Custom Mean is selected</li>
                    </ng-container>
                  </ul>
                  </div>
              </div>
          </div>
          <app-custom-reports-aesthetics *ngIf="isCustomReport" [study_name]="selected_study"
          (closePopup)="closeCustomReportPop()" [client_name]="selected_client"
          [showBrandAnalysis]="isBrandAnalysisActive" [showCrosstab]="isCrosstabActive"></app-custom-reports-aesthetics>
          <div class="feature-section-component" *ngIf="isCustomVariable && !isCreateCustomGroup ">
            <app-shared-popup *ngIf="(isCustomGroupClick ) && isCustomVariable"
              [isSnapshotCustomGroupClick]="isCustomGroupClick && isCustomVariable"
              [loadCustomGroupUserDefinedData]="loadCustomGroupUserDefinedData"
              [loadCustomGroupSharedWithMeData]="loadCustomGroupSharedWithMeData" [showLoaderPopUp]="false"
              [isCustomGroups]="true" [isShareMetric]="true" (isCustomGroupVisible)="handleCustomGroupPopUp($event)"
              (bindCustomGroupFlags)="bindCustomGroupFlags($event)"></app-shared-popup>
          </div>

                      <app-custom-variables *ngIf="(isCreateCustomGroup || isShareCustomGroupPopupClick || isDeleteCustomGroup)&& (bindCustomGroupFlagsData != null) && isCustomVariable "
                        [selected_study]="selected_study" [loadCustomGroupUserDefinedData]="loadCustomGroupUserDefinedData"
                        [loadCustomGroupSharedWithMeData]="loadCustomGroupSharedWithMeData" [selected_client]="selected_client"
                        [dataArray]="dataArray" (closeCustomVariableScreen)="closeCustomVariableScreen($event)"
                        [bindCustomGroupFlagsData]="bindCustomGroupFlagsData"
                        [isSharedClicked]="isShareCustomGroupPopupClick" [isDeleteClicked]="isDeleteCustomGroup"
                        (customvariable)="customvariable($event)"></app-custom-variables>




        </div>
      </div>
    </div>
    <div class="overLay visible" *ngIf="showLeftPanel"></div>
    <div class="output-view" id="output-div" >
        <div class="selection-top-panel">
            <div class="filter-area" (click)="toggleLeftPanel()" >
                <div class="filter-image"></div>
                <div class="filter-text">Filter</div>
            </div>
            <div [class.hidden]="!isSubmitClicked" class="infoRibbon summaryPanel" #summaryText DocumentClick (DocumentClicked)="closeSelectionSummary();">
                <!--selection summary Panel-->

                <div class="InfoRibbonText">
                    <div class="InforRibbonTextValues" #inforRibbon></div>
                </div>

                <div class="InfoCollapse" (click)="OnSelectionBtnClick()">
                    <div class="arrowToggle info-collapse-icon"></div>
                </div>
                <!-- <div class="InfoCollapse" (click)="selectionSummaryBlock()">
                    <div class="arrowToggle info-collapse-icon"></div>
                </div> -->

                <div class="save-selection-area" (click)="saveSelection()">
                    <div class="save-selection-image"></div>
                    <span class="save-selection-text">Save Selections</span>
                </div>

                <!-- <div class="downloadExport" (click)="toggleContainer()" >
                    <div class="download"></div>
                </div> -->
            </div>
        </div>



          <div class="extraSelections" *ngIf="isSubmitClicked">
            <ng-container *ngIf="isSubmitClicked">
                <div class="sigIndexArea" *ngIf="is_sigtesting && is_indexing && is_indexingShow">
                  <div class="sigArea" *ngIf="is_sigtesting">
                      <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;justify-content: center;"
                          [ngClass]="{'initialSelected': isSigSelected}"
                          (click)="onSigType($event);select('sig',$event)">
                          <p style="width:100%;text-align: center; font-size: 0.75rem;"class="btn-text">Sig</p>
                          <img *ngIf="significanceTypes.length > 1"
                              src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon-sig">
                      </div>
                      <div *ngIf="sigTypeDropdown && significanceTypes.length > 1" class="a" DocumentClick
                          (DocumentClicked)="closeSigDropdown()">
                          <div *ngFor="let type of significanceTypes; trackBy: trackByValue" class="dropdown-values-sig"
                              (click)="onSigTypeClick(type,$event)">
                              <div style="padding-top:3%"><input type="radio" name="type" [value]="type.value"
                                      [checked]="type.selected" class="inputValues">
                              </div>
                              <div class="itemData" title="{{type.name}}">{{type.name}}</div>
                          </div>

                      </div>

                  </div>
                  <div class="indexArea" *ngIf="is_indexing && is_indexingShow">
                      <div style="display:flex;position:relative;width:100%;height:100%;align-items: center;"
                          [ngClass]="{'initialSelected': isIndexSelected}"
                          (click)="select('index',$event)">

                      <p style="width:100%;text-align: center;font-size: 0.75rem;" class="btn-text">Index</p>
                      </div>
                  </div>
              </div>
              <div class="dropdown-container" style="height: 2.1rem;">

                  <div class="significanceDropdown"
     DocumentClick
     (DocumentClicked)="closeSignificance()"
     *ngIf="sigConBaseToggle && showSignificanceDropdown">
                      <div>Significance</div>
                      <div class="significance-dropdown-outer-body">


                          <div class="dd" (click)="onSignificanceDropdown()">
                              <p class="dropdown-btn-text">{{displaySignificance}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': significanceDropdownToggle}"></div>
                          </div>
                          <div *ngIf="significanceDropdownToggle" class="b show-dropdown">
                              <div *ngFor="let item of significanceVal; trackBy: trackByKey" class="dropdown-values"
                                  (click)="significanceSelected1(item,$event)">

                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': selectedSignificance === item}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                      <div class="reference-icon-style"
                                          *ngIf="item.key=='Reference'">
                                          <!-- src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" -->
                                          <div [ngClass]=" !displayBrand ? 'Down-Arrow-reference' : 'Up-Arrow-reference'"></div>
                                      </div>

                                  </div>
                                  <div *ngIf="item.key=='Reference' && displayBrand" class="mainBrandDiv sig-ref-dropdown-container show-dropdown">
                                      <!-- Main Panel -->
                                      <div class="sig-ref-main-panel">
                                          <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                              <input type="text" [(ngModel)]="searchQuery" class="searchInput"
                                                  placeholder="Search" />
                                              <div class="search-icon"></div>
                                          </div>
                                          <div class="sig-ref-dropdown-block">
                                              <ng-container *ngFor="let item of allSigBrands| search : searchQuery : ['MetricOption']; trackBy: trackByMetricOption; let i = index">
                                                  <!-- Items WITHOUT nested levels: Show radio button only -->
                                                  <div *ngIf="!item.hasNextLevel"
                                                      class="sig-ref-dropdown-values sig-ref-flat-item" (click)="brandSig(item,$event)"
                                                      [ngClass]="{'selected-item': selectedReference === item}"
                                                      [title]="item.MetricOption">
                                                      <div class="sig-ref-radio-container"><input type="radio" name="sig-section"
                                                              [value]="item.MetricOption" [checked]="item.isSelected"
                                                              class="inputValues">
                                                      </div>
                                                      <div class="sig-brandPara">{{item.MetricOption}}</div>
                                                  </div>

                                                  <!-- Items WITH nested levels: Show expand arrow on RIGHT (NO radio button) -->
                                                  <div *ngIf="item.hasNextLevel"
                                                      class="sig-ref-dropdown-values sig-ref-expandable-item"
                                                      [ngClass]="{'expanded': selectedSigAudienceLevel1 === item}"
                                                      (click)="toggleSigAudienceLevel1Expansion(item, $event)"
                                                      [title]="item.MetricOption">
                                                      <div class="sig-brandPara">{{item.MetricOption}}</div>
                                                      <div class="sig-ref-arrow-container" [style.transform]="item.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'">
                                                      </div>
                                                  </div>
                                              </ng-container>
                                          </div>
                                      </div>

                                      <!-- Side Panel for Level2 items -->
                                      <div *ngIf="selectedSigAudienceLevel1" class="sig-ref-side-panel">
                                          <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                              <input type="text" [(ngModel)]="sigSearchLevel2Query" class="searchInput"
                                                  placeholder="Search" />
                                              <div class="search-icon"></div>
                                          </div>
                                          <div class="sig-ref-dropdown-block">
                                              <ng-container *ngFor="let level2Item of selectedSigAudienceLevel1.Level2_children; trackBy: trackByLevel2Value">
                                                  <!-- Level2 items WITHOUT Level3: Show radio button -->
                                                  <div *ngIf="!level2Item.hasNextLevel"
                                                      [hidden]="sigSearchLevel2Query && !level2Item.Level2_value.toLowerCase().includes(sigSearchLevel2Query.toLowerCase())"
                                                      class="sig-ref-dropdown-values sig-ref-level2-item"
                                                      (click)="selectSigAudienceLevel2(selectedSigAudienceLevel1, level2Item, $event)"
                                                      [ngClass]="{'selected-item': selectedSigBrand?.MetricOption === level2Item.Level2_value}"
                                                      [title]="level2Item.Level2_value">
                                                      <div class="sig-ref-radio-container"><input type="radio" name="sig-level2-section"
                                                              [value]="level2Item.Level2_value" [checked]="selectedSigBrand?.MetricOption === level2Item.Level2_value" class="inputValues">
                                                      </div>
                                                      <div class="sig-brandPara">{{level2Item.Level2_value}}</div>
                                                  </div>
                                                  <!-- Level2 items WITH Level3: Show expand arrow -->
                                                  <div *ngIf="level2Item.hasNextLevel"
                                                      [hidden]="sigSearchLevel2Query && !level2Item.Level2_value.toLowerCase().includes(sigSearchLevel2Query.toLowerCase())"
                                                      class="sig-ref-dropdown-values sig-ref-expandable-item"
                                                      [ngClass]="{'expanded': selectedSigAudienceLevel2 === level2Item}"
                                                      (click)="toggleSigAudienceLevel2Expansion(level2Item, $event)"
                                                      [title]="level2Item.Level2_value">
                                                      <div class="sig-brandPara">{{level2Item.Level2_value}}</div>
                                                      <div class="sig-ref-arrow-container"></div>
                                                  </div>
                                              </ng-container>
                                          </div>
                                      </div>

                                      <!-- Side Panel for Level3 items -->
                                      <div *ngIf="selectedSigAudienceLevel2" class="sig-ref-side-panel sig-ref-level3-panel">
                                          <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                              <input type="text" [(ngModel)]="sigSearchLevel3Query" class="searchInput"
                                                  placeholder="Search" />
                                              <div class="search-icon"></div>
                                          </div>
                                          <div class="sig-ref-dropdown-block">
                                              <ng-container *ngFor="let level3Item of selectedSigAudienceLevel2.Level3">
                                                  <!-- Level3 items WITHOUT Level4: Show radio button -->
                                                  <div *ngIf="!level3Item.hasNextLevel"
                                                      [hidden]="sigSearchLevel3Query && !level3Item.Level3_value.toLowerCase().includes(sigSearchLevel3Query.toLowerCase())"
                                                      class="sig-ref-dropdown-values sig-ref-level2-item"
                                                      (click)="selectSigAudienceLevel3(selectedSigAudienceLevel1, selectedSigAudienceLevel2, level3Item, $event)"
                                                      [ngClass]="{'selected-item': selectedSigBrand?.MetricOption === level3Item.Level3_value}"
                                                      [title]="level3Item.Level3_value">
                                                      <div class="sig-ref-radio-container"><input type="radio" name="sig-level3-section"
                                                              [value]="level3Item.Level3_value" [checked]="selectedSigBrand?.MetricOption === level3Item.Level3_value" class="inputValues">
                                                      </div>
                                                      <div class="sig-brandPara">{{level3Item.Level3_value}}</div>
                                                  </div>
                                                  <!-- Level3 items WITH Level4: Show expand arrow -->
                                                  <div *ngIf="level3Item.hasNextLevel"
                                                      [hidden]="sigSearchLevel3Query && !level3Item.Level3_value.toLowerCase().includes(sigSearchLevel3Query.toLowerCase())"
                                                      class="sig-ref-dropdown-values sig-ref-expandable-item"
                                                      [ngClass]="{'expanded': selectedSigAudienceLevel3 === level3Item}"
                                                      (click)="toggleSigAudienceLevel3Expansion(level3Item, $event)"
                                                      [title]="level3Item.Level3_value">
                                                      <div class="sig-brandPara">{{level3Item.Level3_value}}</div>
                                                      <div class="sig-ref-arrow-container"></div>
                                                  </div>
                                              </ng-container>
                                          </div>
                                      </div>

                                      <!-- Side Panel for Level4 items -->
                                      <div *ngIf="selectedSigAudienceLevel3" class="sig-ref-side-panel sig-ref-level4-panel">
                                          <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                              <input type="text" [(ngModel)]="sigSearchLevel4Query" class="searchInput"
                                                  placeholder="Search" />
                                              <div class="search-icon"></div>
                                          </div>
                                          <div class="sig-ref-dropdown-block">
                                              <ng-container *ngFor="let level4Item of selectedSigAudienceLevel3.Level4">
                                                  <!-- Level4 items WITHOUT Level5: Show radio button -->
                                                  <div *ngIf="!level4Item.hasNextLevel"
                                                      [hidden]="sigSearchLevel4Query && !level4Item.Level4_value.toLowerCase().includes(sigSearchLevel4Query.toLowerCase())"
                                                      class="sig-ref-dropdown-values sig-ref-level2-item"
                                                      (click)="selectSigAudienceLevel4(selectedSigAudienceLevel1, selectedSigAudienceLevel2, selectedSigAudienceLevel3, level4Item, $event)"
                                                      [ngClass]="{'selected-item': selectedSigBrand?.MetricOption === level4Item.Level4_value}"
                                                      [title]="level4Item.Level4_value">
                                                      <div class="sig-ref-radio-container"><input type="radio" name="sig-level4-section"
                                                              [value]="level4Item.Level4_value" [checked]="selectedSigBrand?.MetricOption === level4Item.Level4_value" class="inputValues">
                                                      </div>
                                                      <div class="sig-brandPara">{{level4Item.Level4_value}}</div>
                                                  </div>
                                                  <!-- Level4 items WITH Level5: Show expand arrow -->
                                                  <div *ngIf="level4Item.hasNextLevel"
                                                      [hidden]="sigSearchLevel4Query && !level4Item.Level4_value.toLowerCase().includes(sigSearchLevel4Query.toLowerCase())"
                                                      class="sig-ref-dropdown-values sig-ref-expandable-item"
                                                      [ngClass]="{'expanded': selectedSigAudienceLevel4 === level4Item}"
                                                      (click)="toggleSigAudienceLevel4Expansion(level4Item, $event)"
                                                      [title]="level4Item.Level4_value">
                                                      <div class="sig-brandPara">{{level4Item.Level4_value}}</div>
                                                      <div class="sig-ref-arrow-container"></div>
                                                  </div>
                                              </ng-container>
                                          </div>
                                      </div>

                                      <!-- Side Panel for Level5 items -->
                                      <div *ngIf="selectedSigAudienceLevel4" class="sig-ref-side-panel sig-ref-level5-panel">
                                          <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                              <input type="text" [(ngModel)]="sigSearchLevel5Query" class="searchInput"
                                                  placeholder="Search" />
                                              <div class="search-icon"></div>
                                          </div>
                                          <div class="sig-ref-dropdown-block">
                                              <div *ngFor="let level5Item of selectedSigAudienceLevel4.Level5"
                                                  [hidden]="sigSearchLevel5Query && !level5Item.Level5_value.toLowerCase().includes(sigSearchLevel5Query.toLowerCase())"
                                                  class="sig-ref-dropdown-values sig-ref-level2-item"
                                                  (click)="selectSigAudienceLevel5(selectedSigAudienceLevel1, selectedSigAudienceLevel2, selectedSigAudienceLevel3, selectedSigAudienceLevel4, level5Item, $event)"
                                                  [ngClass]="{'selected-item': selectedSigBrand?.MetricOption === level5Item.Level5_value}"
                                                  [title]="level5Item.Level5_value">
                                                  <div class="sig-ref-radio-container"><input type="radio" name="sig-level5-section"
                                                          [value]="level5Item.Level5_value" [checked]="selectedSigBrand?.MetricOption === level5Item.Level5_value" class="inputValues">
                                                  </div>
                                                  <div class="sig-brandPara">{{level5Item.Level5_value}}</div>
                                              </div>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>

                      </div>

                  </div>
    <div class="confidenceLeveldropdown"
     (click)="onCLclick()" *ngIf="sigConBaseToggle && showConfidenceDropdown"
     [ngClass]="(significanceSelectedValue === 'Reference' || selectedBrandKey || selectedBrandKeyRef || (!selectedBrandKeyRef && !significanceDropdownToggle && selectedSignificance && significanceSelectedValue != 'None' && significanceSelectedValue != 'Reference') ) ? 'enabled' : 'disabled'">
     <div>Confidence Level </div>
              <div class="confidence-level-outer-body" [ngClass]="(significanceSelectedValue === 'Reference' || (!selectedBrandKeyRef && !significanceDropdownToggle && selectedSignificance && significanceSelectedValue != 'None' && significanceSelectedValue != 'Reference') ) ? 'enabled' : 'disabled'">
                          <div class="dd1" (click)="onConfidenceLevelDropdown()">
                              <p class="dropdown-btn-text">{{displayConfidenceLevel}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': ConfidenceLevelDropDownToggle}"
                                  style="top:23%"></div>
                          </div>
                          <div *ngIf="ConfidenceLevelDropDownToggle" class="Confidence-level-dropdown show-dropdownConfidence">
                              <div *ngFor="let item of confidenceLevel; trackBy: trackByKey" class="dropdown-values"
                                  (click)="confidenceLevelSelected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': displayConfidenceLevel === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>


                      </div>
                  </div>
                  <div class="referenceDropdownCSS" *ngIf="!sigConBaseToggle">
                      <div>{{ is_indexing && is_indexingShow && !is_sigtesting ? 'Index Reference' : 'Reference' }}</div>
                      <div class="reference-dropdown-outer-body">


                          <div class="dd" (click)="onReferenceDropdown()" DocumentClick
                              (DocumentClicked)="closeReferenceDropdown()">
                              <p class="brandDisplayDiv">{{displayReference}}</p>
                              <img src="../../../../assets/ImagesSnapshot/Public/key-downDown.svg" alt="" class="icon">
                          </div>
                          <div *ngIf="referenceDropdownToggle" class="ref ref-dropdown-container show-dropdown">
                              <!-- Main Panel -->
                              <div class="ref-main-panel">
                                  <div class="search-row-block" (click)="searchBoxClick($event)">
                                      <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
                                      <div class="search-icon"></div>
                                  </div>
                                  <div class="reference-dropdown-block">
                                      <ng-container *ngFor="let item of allbrands| search : searchQuery : ['MetricOption']; trackBy: trackByMetricOption; let i = index">
                                          <!-- Items WITHOUT nested levels: Show radio button only -->
                                          <div *ngIf="!item.hasNextLevel"
                                              class="ref-dropdown-values ref-flat-item" (click)="referenceSelected(item)"
                                              [ngClass]="{'selected-item': selectedReference === item}"
                                              [title]="item.MetricOption">
                                              <div class="ref-radio-container"><input type="radio" name="section"
                                                      [value]="item.MetricOption" [checked]="item.isSelected" class="inputValues">
                                              </div>
                                              <div class="brandPara">{{item.MetricOption}}</div>
                                          </div>

                                          <!-- Items WITH nested levels: Show expand arrow on RIGHT (NO radio button) -->
                                          <div *ngIf="item.hasNextLevel"
                                              class="ref-dropdown-values ref-expandable-item"
                                              [ngClass]="{'expanded': selectedAudienceLevel1 === item}"
                                              (click)="toggleAudienceLevel1Expansion(item, $event)"
                                              [title]="item.MetricOption">
                                              <div class="brandPara">{{item.MetricOption}}</div>
                                              <div class="ref-arrow-container" [style.transform]="item.isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'">
                                              </div>
                                          </div>
                                      </ng-container>
                                  </div>
                              </div>

                              <!-- Side Panel for Level2 items -->
                              <div *ngIf="selectedAudienceLevel1" class="ref-side-panel">
                                  <div class="search-row-block" (click)="searchBoxClick($event)">
                                      <input type="text" [(ngModel)]="refSearchLevel2Query" class="searchInput" placeholder="Search" />
                                      <div class="search-icon"></div>
                                  </div>
                                  <div class="reference-dropdown-block">
                                      <ng-container *ngFor="let level2Item of selectedAudienceLevel1.Level2_children; trackBy: trackByLevel2Value">
                                          <!-- Level2 items WITHOUT Level3: Show radio button -->
                                          <div *ngIf="!level2Item.hasNextLevel"
                                              [hidden]="refSearchLevel2Query && !level2Item.Level2_value.toLowerCase().includes(refSearchLevel2Query.toLowerCase())"
                                              class="ref-dropdown-values ref-level2-item"
                                              (click)="selectAudienceLevel2(selectedAudienceLevel1, level2Item, $event)"
                                              [ngClass]="{'selected-item': selectedReference?.MetricOption === level2Item.Level2_value}"
                                              [title]="level2Item.Level2_value">
                                              <div class="ref-radio-container"><input type="radio" name="level2-section"
                                                      [value]="level2Item.Level2_value" [checked]="selectedReference?.MetricOption === level2Item.Level2_value" class="inputValues">
                                              </div>
                                              <div class="brandPara">{{level2Item.Level2_value}}</div>
                                          </div>
                                          <!-- Level2 items WITH Level3: Show expand arrow -->
                                          <div *ngIf="level2Item.hasNextLevel"
                                              [hidden]="refSearchLevel2Query && !level2Item.Level2_value.toLowerCase().includes(refSearchLevel2Query.toLowerCase())"
                                              class="ref-dropdown-values ref-expandable-item"
                                              [ngClass]="{'expanded': selectedAudienceLevel2 === level2Item}"
                                              (click)="toggleAudienceLevel2Expansion(level2Item, $event)"
                                              [title]="level2Item.Level2_value">
                                              <div class="brandPara">{{level2Item.Level2_value}}</div>
                                              <div class="ref-arrow-container"></div>
                                          </div>
                                      </ng-container>
                                  </div>
                              </div>

                              <!-- Side Panel for Level3 items -->
                              <div *ngIf="selectedAudienceLevel2" class="ref-side-panel ref-level3-panel">
                                  <div class="search-row-block" (click)="searchBoxClick($event)">
                                      <input type="text" [(ngModel)]="refSearchLevel3Query" class="searchInput" placeholder="Search" />
                                      <div class="search-icon"></div>
                                  </div>
                                  <div class="reference-dropdown-block">
                                      <ng-container *ngFor="let level3Item of selectedAudienceLevel2.Level3">
                                          <!-- Level3 items WITHOUT Level4: Show radio button -->
                                          <div *ngIf="!level3Item.hasNextLevel"
                                              [hidden]="refSearchLevel3Query && !level3Item.Level3_value.toLowerCase().includes(refSearchLevel3Query.toLowerCase())"
                                              class="ref-dropdown-values ref-level2-item"
                                              (click)="selectAudienceLevel3(selectedAudienceLevel1, selectedAudienceLevel2, level3Item, $event)"
                                              [ngClass]="{'selected-item': selectedReference?.MetricOption === level3Item.Level3_value}"
                                              [title]="level3Item.Level3_value">
                                              <div class="ref-radio-container"><input type="radio" name="level3-section"
                                                      [value]="level3Item.Level3_value" [checked]="selectedReference?.MetricOption === level3Item.Level3_value" class="inputValues">
                                              </div>
                                              <div class="brandPara">{{level3Item.Level3_value}}</div>
                                          </div>
                                          <!-- Level3 items WITH Level4: Show expand arrow -->
                                          <div *ngIf="level3Item.hasNextLevel"
                                              [hidden]="refSearchLevel3Query && !level3Item.Level3_value.toLowerCase().includes(refSearchLevel3Query.toLowerCase())"
                                              class="ref-dropdown-values ref-expandable-item"
                                              [ngClass]="{'expanded': selectedAudienceLevel3 === level3Item}"
                                              (click)="toggleAudienceLevel3Expansion(level3Item, $event)"
                                              [title]="level3Item.Level3_value">
                                              <div class="brandPara">{{level3Item.Level3_value}}</div>
                                              <div class="ref-arrow-container"></div>
                                          </div>
                                      </ng-container>
                                  </div>
                              </div>

                              <!-- Side Panel for Level4 items -->
                              <div *ngIf="selectedAudienceLevel3" class="ref-side-panel ref-level4-panel">
                                  <div class="search-row-block" (click)="searchBoxClick($event)">
                                      <input type="text" [(ngModel)]="refSearchLevel4Query" class="searchInput" placeholder="Search" />
                                      <div class="search-icon"></div>
                                  </div>
                                  <div class="reference-dropdown-block">
                                      <ng-container *ngFor="let level4Item of selectedAudienceLevel3.Level4">
                                          <!-- Level4 items WITHOUT Level5: Show radio button -->
                                          <div *ngIf="!level4Item.hasNextLevel"
                                              [hidden]="refSearchLevel4Query && !level4Item.Level4_value.toLowerCase().includes(refSearchLevel4Query.toLowerCase())"
                                              class="ref-dropdown-values ref-level2-item"
                                              (click)="selectAudienceLevel4(selectedAudienceLevel1, selectedAudienceLevel2, selectedAudienceLevel3, level4Item, $event)"
                                              [ngClass]="{'selected-item': selectedReference?.MetricOption === level4Item.Level4_value}"
                                              [title]="level4Item.Level4_value">
                                              <div class="ref-radio-container"><input type="radio" name="level4-section"
                                                      [value]="level4Item.Level4_value" [checked]="selectedReference?.MetricOption === level4Item.Level4_value" class="inputValues">
                                              </div>
                                              <div class="brandPara">{{level4Item.Level4_value}}</div>
                                          </div>
                                          <!-- Level4 items WITH Level5: Show expand arrow -->
                                          <div *ngIf="level4Item.hasNextLevel"
                                              [hidden]="refSearchLevel4Query && !level4Item.Level4_value.toLowerCase().includes(refSearchLevel4Query.toLowerCase())"
                                              class="ref-dropdown-values ref-expandable-item"
                                              [ngClass]="{'expanded': selectedAudienceLevel4 === level4Item}"
                                              (click)="toggleAudienceLevel4Expansion(level4Item, $event)"
                                              [title]="level4Item.Level4_value">
                                              <div class="brandPara">{{level4Item.Level4_value}}</div>
                                              <div class="ref-arrow-container"></div>
                                          </div>
                                      </ng-container>
                                  </div>
                              </div>

                              <!-- Side Panel for Level5 items -->
                              <div *ngIf="selectedAudienceLevel4" class="ref-side-panel ref-level5-panel">
                                  <div class="search-row-block" (click)="searchBoxClick($event)">
                                      <input type="text" [(ngModel)]="refSearchLevel5Query" class="searchInput" placeholder="Search" />
                                      <div class="search-icon"></div>
                                  </div>
                                  <div class="reference-dropdown-block">
                                      <div *ngFor="let level5Item of selectedAudienceLevel4.Level5"
                                          [hidden]="refSearchLevel5Query && !level5Item.Level5_value.toLowerCase().includes(refSearchLevel5Query.toLowerCase())"
                                          class="ref-dropdown-values ref-level2-item"
                                          (click)="selectAudienceLevel5(selectedAudienceLevel1, selectedAudienceLevel2, selectedAudienceLevel3, selectedAudienceLevel4, level5Item, $event)"
                                          [ngClass]="{'selected-item': selectedReference?.MetricOption === level5Item.Level5_value}"
                                          [title]="level5Item.Level5_value">
                                          <div class="ref-radio-container"><input type="radio" name="level5-section"
                                                  [value]="level5Item.Level5_value" [checked]="selectedReference?.MetricOption === level5Item.Level5_value" class="inputValues">
                                          </div>
                                          <div class="brandPara">{{level5Item.Level5_value}}</div>
                                      </div>
                                  </div>
                              </div>
                          </div>

                      </div>
                  </div>
                  <div class="baseDropdown" *ngIf="showBaseDropdown">
                      <div>Base</div>
                      <div class="base-dropdown-outer-body">
                          <div class="dd" [ngClass]="{'custom-base-dd': showCustomBaseOnPage}"  (click)="onBaseDropdown()" DocumentClick
                              (DocumentClicked)="closeBaseDropdown()">
                              <p class="dropdown-btn-text">{{baseselected}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': BaseDropDownToggle}"
                                  style="top:23%"></div>
                          </div>
                          <div *ngIf="BaseDropDownToggle && isAnswerBase && !isCustomBaseSelected" class="Base-dropdown show-dropdown"
                              [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                              <div *ngFor="let item of base; trackBy: trackByKey" class="dropdown-values"
                                  [ngClass]="{ 'answer-base-disabled': item.key === 'Answer Base' && !enableSnapshotNonTotalBaseOptions }"
                                  (click)="baseSelected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': baseselected === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>                                  
                              </div>
                          </div>
                          <div *ngIf="BaseDropDownToggle && !isAnswerBase && !isCustomBaseSelected" class="Base-dropdown show-dropdown"
                              [ngClass]="{'Index-Base-dropdown': isIndexSelected}">
                              <div *ngFor="let item of base2; trackBy: trackByKey" class="dropdown-values" (click)="base2Selected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': baseselected === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div *ngIf="BaseDropDownToggle && isCustomBaseSelected" class="Base-dropdown show-dropdown"
                              [ngClass]="{'custom-base-dd': showCustomBaseOnPage, 'Index-Base-dropdown': isIndexSelected}">
                              <div *ngFor="let item of base; trackBy: trackByKey" class="dropdown-values" (click)="baseSelected($event)">
                                  <div *ngIf="item.key !== 'Base'" style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': baseselected === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                                  <ng-container *ngIf="item.key === 'Base' && showCustomBaseOnPage">
                                    <div
                                      class="snapshot-base-custom-extra-wrap"
                                      [ngClass]="{ 'base-options-disabled': !enableSnapshotNonTotalBaseOptions }"
                                    >
                                      <div style="display:flex; width:100%;position:relative">
                                        <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                            [ngClass]="{'selected-item': baseselected === item.key}">
                                            <span class="dropdown-text-values">{{item.key}}</span>
                                        </div>
                                        <div class="reference-icon-style"
                                            *ngIf="(CustomBaseOptions && CustomBaseOptions.length > 0) || !enableSnapshotNonTotalBaseOptions">
                                            <div [ngClass]=" !displayCustomBaseBrand ? 'Down-Arrow-reference' : 'Up-Arrow-reference'"></div>
                                        </div>
                                      </div>
                                      <div *ngIf="displayCustomBaseBrand" class="mainBrandDiv show-dropdown">
                                        <div class="search-row-block-significance" (click)="searchBoxClick($event)">
                                            <input type="text" [(ngModel)]="customBaseSearchQuery" class="searchInput"
                                                placeholder="Search" [disabled]="!enableSnapshotNonTotalBaseOptions" />
                                            <!-- <div class="search-icon"></div> -->
                                        </div>
                                        <div style="width:100%;height:9rem;overflow: auto;">
                                            <div *ngFor="let customBase of filteredCustomBaseOptions; trackBy: trackByIndex; let i = index"
                                                class="brandsDiv"
                                                [ngClass]="{'selected-item': selectedCustomBaseReference.includes(customBase)}"
                                                (click)="toggleCustomBase(customBase, $event)">
                                                <div style="padding-top:3%">                                                
                                                <input type="checkbox"
                                                        [checked]="enableSnapshotNonTotalBaseOptions && ((selectedCustomBaseReference.includes(customBase) &&
                                                                  !tempRemovedCustomBase.includes(customBase))
                                                                  || tempSelectedCustomBase.includes(customBase)
                                                                )"
                                                        class="inputValues base-checkbox-color"
                                                        [disabled]="!enableSnapshotNonTotalBaseOptions"
                                                />
                                                </div>                                              
                                                <div class="brandPara" style="padding-left:4%"
                                                    [title]="customBase">
                                                    {{customBase}}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="base-dropdown-footer" style="padding-left:4%" (click)="$event.stopPropagation()">
                                            <div class="btn btn-typography btn-apply" [class.disabled]="!isApplyBase || !enableSnapshotNonTotalBaseOptions" [ngClass]="(isApplyBase && enableSnapshotNonTotalBaseOptions)?'btn-active':'btn-notactive'"
                                            (click)="applyBaseSelection()">Apply</div>

                                            <div class="btn btn-typography btn-cancel" [class.disabled]="!isApplyBase && enableSnapshotNonTotalBaseOptions"
                                            (click)="cancelBaseSelection()">Cancel</div> 
                                        </div>
                                      </div>
                                    </div>
                                  </ng-container>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div class="weightdropdownContainer"  *ngIf="weight.length>1">
                      <div>Weight </div>
                      <div class="weighted-dropdown-outer-body">

                          <div class="dd" (click)="onWeightDropdown()" DocumentClick
                              (DocumentClicked)="closeWeightDropdown()">
                              <p class="dropdown-btn-text">{{weightSelectedValue}}</p>
                              <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': weightDropDownToggle}"
                                  style="top:23%"></div>
                          </div>
                          <div *ngIf="weightDropDownToggle" class="weight-dropdown show-dropdown"
                              [ngClass]="{'Index-weight-dropdown': isIndexSelected}">
                              <div *ngFor="let item of weight; trackBy: trackByKey" class="dropdown-values" (click)="weightSelected($event)">
                                  <div style="display:flex; width:100%;position:relative">
                                      <div class="itemData" style="height:1.3rem" title="{{item.key}}"
                                          [ngClass]="{'selected-item': weightSelectedValue === item.key}">
                                          <span class="dropdown-text-values">{{item.key}}</span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                <!-- ...existing code... -->
          <div class="brandDropdownContainer" *ngIf="hasBrandDependentCharts && brandList.length">
            <div>Brand</div>
            <div class="brand-dropdown-outer-body">
              <div class="dd" (click)="onBrandDropdown()" DocumentClick
                (DocumentClicked)="closeBrandDropdown()">
                <p class="dropdown-btn-text">{{brandSelectedValue || 'Select'}}</p>
                <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': brandDropDownToggle}"
                  style="top:23%"></div>
              </div>
              <div *ngIf="brandDropDownToggle" class="brand-dropdown show-dropdown">
                <!-- SEARCH INPUT AT TOP -->
                <div class="brand-search-container" (click)="$event.stopPropagation()">
                  <input type="text"
                         class="brand-search-input"
                         placeholder="Search brands..."
                         [(ngModel)]="brandSearchQuery"
                         (keydown)="$event.stopPropagation()"
                         (input)="$event.stopPropagation()" />
                </div>
                <div *ngFor="let item of filteredBrandList; trackBy: trackByValue" class="dropdown-values" (click)="brandSelected(item)">
                  <div style="display:flex; width:100%;position:relative">
                    <div class="ref-radio-container"><input type="radio" name="brand-select"
                        [value]="item.value" [checked]="brandSelectedValue === item.value" class="inputValues">
                    </div>
                    <div class="dropdown-text-values" title="{{item.value}}">{{item.value}}</div>
                  </div>
                </div>
                <!-- show "no results" message -->
                <div class="dropdown-no-results" *ngIf="filteredBrandList.length === 0">
                  No brands found
                </div>
              </div>
            </div>
          </div>
<!-- ...existing code... -->
              </div>
              <div class="insightcontainer">
                  <div class="insight-download-area">
                    <div class="output-filter-toolbar" *ngIf="showTextToTopicsOutputFilters">
                      <div class="output-filter-control">
                        <div class="output-filter-label-wrap">
                          <span class="output-info-icon" tabindex="0">
                            i
                            <div class="output-info-tooltip">This dropdown controls all widgets below</div>
                          </span>
                          <span class="output-filter-label">Sentiment</span>
                        </div>
                        <div class="output-filter-dropdown-outer-body">
                          <div class="output-filter-dd" (click)="onSentimentDropdown()" DocumentClick
                            (DocumentClicked)="closeSentimentDropdown()">
                            <p class="dropdown-btn-text">{{sentimentSelectedValue}}</p>
                            <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': sentimentDropDownToggle}"
                              style="top:23%"></div>
                          </div>
                          <div *ngIf="sentimentDropDownToggle" class="output-filter-dropdown sentiment-output-dropdown show-dropdown" (click)="$event.stopPropagation()">
                            <div class="sentiment-option-list">
                              <div class="output-filter-option" (click)="toggleAllSentiments($event)">
                                <input type="checkbox" class="output-filter-checkbox" [checked]="areAllSentimentsSelected()" />
                                <span>Select All</span>
                              </div>
                              <div *ngFor="let item of sentimentOptions; trackBy: trackByValue" class="output-filter-option" (click)="toggleSentimentOption(item, $event)">
                                <input type="checkbox" class="output-filter-checkbox" [checked]="item.selected" />
                                <span>{{item.label}}</span>
                              </div>
                            </div>
                            <div class="sentiment-submit-row">
                              <button type="button" class="sentiment-submit-btn" (click)="submitSentimentSelection($event)">Submit</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="output-filter-control">
                        <div class="output-filter-label-wrap">
                          <span class="output-info-icon" tabindex="0">
                            i
                            <div class="output-info-tooltip">This dropdown controls Topics and Verbatims widget below</div>
                          </span>
                          <span class="output-filter-label">Topics</span>
                        </div>
                        <div class="output-filter-dropdown-outer-body">
                          <div class="output-filter-dd" (click)="onTopicDropdown()" DocumentClick
                            (DocumentClicked)="closeTopicDropdown()">
                            <p class="dropdown-btn-text">{{selectedTopicValue}}</p>
                            <div alt="" class="icon Down-Arrow" [ngClass]="{'Up-Arrow': topicDropDownToggle}"
                              style="top:23%"></div>
                          </div>
                          <div *ngIf="topicDropDownToggle" class="output-filter-dropdown topic-output-dropdown show-dropdown" (click)="$event.stopPropagation()">
                            <div class="topic-top-row" (click)="toggleTop8Radio($event)">
                              <input type="radio" class="topic-radio" [checked]="isTop8Selected" />
                              <span>Top 8</span>
                              <span class="output-info-icon" tabindex="0" (click)="$event.stopPropagation()">
                                i
                                <div class="output-info-tooltip-top8-tooltip">Top 8 based on the frequency of topics in selected time period{{ selectedTimePeriodLabel ? ' (' + selectedTimePeriodLabel + ')' : '' }}</div>
                              </span>
                            </div>
                            <div class="topic-search-row">
                              <div class="topic-search-box">
                                <input type="text" class="topic-search-input" placeholder="Search" [(ngModel)]="topicSearchQuery" />
                                <span class="topic-clear-icon" *ngIf="topicSearchQuery" (click)="clearTopicSearch($event)" title="Clear search"></span>
                                <span class="topic-search-icon"></span>
                              </div>
                              <span class="topic-reset-icon" (click)="resetTopicSelection($event)" title="Reset"></span>
                            </div>
                            <div class="topic-option-list">
                              <div *ngFor="let topic of filteredTopicOptions; trackBy: trackByValue" class="topic-option-row" [class.topic-option-disabled]="isTopicDisabled(topic)" [class.topic-option-top8]="isTop8Selected && topic.isTop8" (click)="toggleTopicOption(topic, $event)">
                                <input type="checkbox" class="topic-checkbox" [checked]="topic.selected" [disabled]="isTopicDisabled(topic)" />
                                <span>{{topic.label}}</span>
                              </div>
                            </div>
                            <div class="topic-submit-row">
                              <button type="button" class="topic-submit-btn" (click)="submitTopicSelection($event)">Submit</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                      <div class="download-icon-background"  *ngIf="!(!excelExport && !editablePPT && !staticPPT)" [ngClass]="showContainer && showExportContainer ? 'bg-download-active' :'bg-download-inactive'" (click)="toggleContainer()" DocumentClick (DocumentClicked)="closeContainer()">
                          <div class="download-icon" [ngClass]="showContainer && showExportContainer ?'bg-download-active-image':'bg-download-inactive-image'"></div>
                      </div>
                      <!-- <div class="insight-btn" *ngIf="true">
                          <div class="insight-image">
                          </div>
                          <div class="insight-text" (click)="OnInsigthsbuttonClick()">
                              Insights
                          </div>
                      </div> -->

                  <div class="insightsbuttonContainer" *ngIf="is_AI_Integration">
                    <div class="insigths_btn" (click)="OnInsigthsbuttonClick()">
                      <!-- <div class="btn-icon SnapShotInsights-Icon"></div> -->
                      <div class="insight-image"></div>
                      <div class="btn-text" style="width: 55%;font-size: 0.75rem;color: #fff;">
                        Insights
                      </div>
                    </div>
                  </div>

                  </div>
                  <!-- <div class="polygon showPanel" *ngIf="showContainer && showExportContainer">
                      <div class="polygon-icon poly-icon"></div>
                  </div> -->
                  <div class="setting-container showPanel" [ngStyle]="!is_AI_Integration ? { 'top': '18%', 'right': '0.7%' } : {}" *ngIf="showContainer && showExportContainer">
                        <!-- Text to Topic: hide trended PPT. Remove `&& !showTextToTopicsOutputFilters` to show it again. -->
                        <div class="setting-blocks editablePPTSettings"  *ngIf="editablePPT && hasTrendline && !isTrendlineInExportsEnabled && !showTextToTopicsOutputFilters" (click)="OnExportClicked('ppt',true)">
                          <div class="setting-block-icon ppt-icon-trend"></div>
                          <div class="setting-block-name">PPT Trended (Editable)</div>
                      </div>
                      <div class="setting-blocks editablePPTSettings"  *ngIf="editablePPT" (click)="OnExportClicked('ppt',false)">
                        <div class="setting-block-icon ppt-icon"></div>
                        <div class="setting-block-name">PPT (Editable)</div>
                      </div>
                      <div class="setting-blocks screengrabPPTSettings"  *ngIf="staticPPT" (click)="screengrabPPTClicked()">
                          <div class="setting-block-icon ppt-icon"></div>
                          <div class="setting-block-name">PPT (Static)</div>
                      </div>
                      <!-- excelexportClicked() -->
                      <div class="setting-blocks excelexportSettings"  *ngIf="excelExport" (click)="OnExportClicked('excel',false)">
                        <div class="setting-block-icon excel-icon"></div>
                        <div class="setting-block-name">Excel</div>
                      </div>
                      <!-- Text to Topic: hide Excel Trendline. Remove `&& !showTextToTopicsOutputFilters` to show it again. -->
                      <div class="setting-blocks excelexportSettings" *ngIf="excelExport && hasTrendline && !showTextToTopicsOutputFilters"  (click)="OnExportClicked('excel', true)">
                          <div class="setting-block-icon excel-icon-trend"></div>
                          <div class="setting-block-name">Excel (Trendline)</div>
                      </div>
                  </div>
              </div>
            </ng-container>

              <!-- //------------------------------------Index----------------------------------- -->

          </div>

        <ng-container *ngIf="isSubmitClicked" >
        <!-- ------------------------------------------------- -->
          <div class="subSectionDiv">
              <!-- <div *ngFor="let item of subSectionNames" class="allSubSectionDiv" (click)="OnSubSectionClick(item)">
                  <div class="subSection" [ngClass]="{'initialSelected': item.isSelected}">{{item.name}}</div>
              </div> -->
          </div>
        <!-- ------------------------------------------------------- -->
        <div style="display: flex; flex-direction: column; min-height: calc(100vh - 5rem);">
        <!-- ------------------------Charts area------------------------------- -->
          <div class="outputWidgetArea" *ngIf="showOutputView" style="height: 100%;flex: 1; overflow-y: auto;" id="widget-display-div">
              <app-custom-widget-output (pageCounterChanged)="onPageCounterChange($event)" (globalColorMapChanged)="onGlobalColorMapChanged($event)" style="width:100%;flex: 1;"
                  [outputData]="output_details" [sigIndex]="sigIndex"></app-custom-widget-output>
          </div>
        <!-- ---------------------------------------- -->

          <div style="display: flex; justify-content: center; align-items: center; height: 100%;"
              *ngIf="!showOutputView && !showDefaultPanel && !isInitialLoading"> No Data Available</div>
        <!-- -----------------------Footer Area------------------------------------- -->

          <div class="outputFooterArea">
              <div class="sampleBtn " (click)="showSampleSizePopup()">
                  <div class="samplesize-btn-text">Sample Size</div>
              </div>
              <div class="footer-text">
                <div class="footer-text-container">
                  <div class="staticLsIsText">
                    <div class="ls-is-text">* - Indicates Low Base ({{LowBase}})</div>
                    <div class="ls-is-text"><span style="font-weight: bold;">I/S</span> - Indicates Insufficient Sample
                        ({{insufficientBase}})</div>
                    <div class="ls-is-text"><span style="font-weight: bold;">NA</span> - Indicates Base = 0</div>
                    <!-- <div class="significance-positive">• Significantly Higher</div>
                    <div class="significance-negative">• Significantly Lower</div> -->
                  </div>
                  <div *ngIf="isIndexSelected" class="indexText" title="{{indexText}}">
                      Note: The indexed value greater than <span style="color:green">{{higherIndexValue}} are denoted
                          by
                          green</span> and in <span style="color:red">Red for values less than
                          {{lowerIndexValue}}</span>
                  </div>
                  <div *ngIf="isSigSelected && displaySignificance != 'None'" class="sigFooterText">
                      <span style="color:green;">• Significantly Higher</span>
                      <span style="color:red;">• Significantly Lower</span>
                  </div>
                </div>
                <div class="pagination-container" *ngIf="showOutputView && this.pageData.length > 1">
                    <div class="page-icon">
                      <div class="vector-1"></div>
                      <div class="vector-2"></div>
                    </div>
                    <div class="page-icon-hover">
                      <div class="page-left" (click)="OnPageClick('left')" [ngClass]="{'disabled': disableLeftClick || pageCounter == 1, 'bg-color-active' : leftClicked, 'bg-color-inactive' : !leftClicked}">
                        <div class="vector-1-hover"></div>
                        <div class="left-text">Prev</div>
                      </div>
                      <div class="page-number-text">
                        {{this.pageCounter}}/{{this.pageData.length}}
                      </div>
                      <div class="page-right" (click)="OnPageClick('right')" [ngClass]="{'disabled':disableRightClick || pageCounter == pageData.length, 'bg-color-active' : rightClicked, 'bg-color-inactive' : !rightClicked}">
                        <div class="right-text" >Next</div>
                        <div class="vector-2-hover"></div>
                      </div>
                      <!-- <div class="vector-2"></div> -->
                    </div>
                </div>

                <div class="i-icon-text">
                  <div *ngIf="stacticText" class="i-icon-trigger">
                    <div class="i-icon-hover">
                      <div class="i-icon-hover-image"></div>
                      <div class="i-icon-hover-text">{{stacticText}}</div>
                      <div class="rectangle"></div>
                    </div>
                    <div class="icon-image"></div>
                  </div>

                  <div class="source-bgs-text"><span class="first-text">Source : </span><span class="second-text">{{ mainStudy }}</span></div>

                </div>
              </div>
              <!-- <div [title]="stacticText" class="staticText"> {{stacticText}}</div> -->
              <!-- <div class="saveSelection-btn config-footer-btn config-ftr" (click)="saveSelection()"
                  [style]="showSaveSelectionButton?('display:flex;'+(_configService.isSemiAggregatedData || _configService.isAggregatedData?'right:2.5% !important':'')):'display:none;'">
                  <div class="btn-icon save-icon"></div>
                  <div class="btn-text">Save Selection</div>
              </div> -->
              <!-- <div class="sampleBtn " (click)="showSampleSizePopup()" *ngIf="!_configService.isSemiAggregatedData && !_configService.isAggregatedData">Sample Size</div> -->
          </div>

        </div>

        </ng-container>
        <!-- <div class="polygon showPanel" *ngIf="showContainer && showExportContainer" >
            <div class="polygon-icon poly-icon"></div>
        </div>
        <div class="setting-container showPanel" *ngIf="showContainer && showExportContainer" >
            <div class="setting-blocks editablePPTSettings"  *ngIf="editablePPT" (click)="editablePPTClicked()">
                <div class="setting-block-icon ppt-icon"></div>
                <div class="setting-block-name">PPT (Editable)</div>
            </div>
            <div class="setting-blocks screengrabPPTSettings"  *ngIf="staticPPT" (click)="screengrabPPTClicked()">
                <div class="setting-block-icon ppt-icon"></div>
                <div class="setting-block-name">PPT (Static)</div>
            </div>
            <div class="setting-blocks excelexportSettings"  (click)="excelexportClicked()">
                <div class="setting-block-icon excel-icon"></div>
                <div class="setting-block-name">Excel</div>
            </div>
        </div> -->



        <!-- ----------------------------------------------------------------- -->



        <!-- ------------------------------------------------------------ -->
    </div>
    <div *ngIf="showSelectionSummary" class="slide-in-wrapper">
      <app-selection-summary-view
        [ngClass]="isSaveSelectionClick ? 'slide-in' : 'slide-out'"
        (SaveSelectionClick)="SaveSelection($event)"
        [isSaveSelectionClick]="isSaveSelectionClick"
        (isSavePopUpVisible)="handleSavePopUP($event)"
        [Header]="summaryViewHeader"
        [isSelectionSummaryClick]="isSelectionSummaryClick"
        [hasBrandDependentCharts]="hasBrandDependentCharts"
      ></app-selection-summary-view>
    </div>
    <div class="overLay2 visible" *ngIf="showSelectionSummary"></div>
    <!-- <div class="no-data-screen DN"> Snapshot is not configured. Please contact Admin.</div> -->

  </div>
</ng-container>

<section style="font-size: 0.7rem;">
  <!-- <app-shared-popup *ngIf="isCustomGroupClick" [isCustomGroupClick]="isCustomGroupClick"
    [loadCustomGroupUserDefinedData]="loadCustomGroupUserDefinedData"
    [loadCustomGroupSharedWithMeData]="loadCustomGroupSharedWithMeData" [showLoaderPopUp]="false"
    [isCustomGroups]="true" [isShareMetric]="true" (isCustomGroupVisible)="handleCustomGroupPopUp($event)"
    (bindCustomGroupFlags)="bindCustomGroupFlags($event)"></app-shared-popup> -->
  <app-custom-reports *ngIf="isCustomReportSnapshotClick" [study_name]="selected_study"
    (closePopup)="closeCustomReportPop()" [client_name]="selected_client"
    [showBrandAnalysis]="is_brandAnalysis"></app-custom-reports>
</section>
<!-- this.outputData -->
<app-shared-popup-snapshot *ngIf="showSampleSizePop" [showSampleSizePopup]="showsamplesizepopup"
  [showInputPopUp]="false" [showErrorPopUp]="false" [popUpParameter]="'SampleSize'"
  [OutputdataObject]="OutputdataObject" [snapshotdata]="this.sampleSizeOutputData" [isTranspose]="false"
  [isTotalBase]="true" [isAnswerBase]="false" [isSampleSize]="isSampleSize"
  [TrendToggleContainer]="TrendToggleContainer" [TrendToggleOn]="TrendToggleOn"
  (closeSamplesizePopUp)="onCloseIconClick($event)" [SnapShotType]="this._configService.selectedSnapshotType"
  [weightSelectedValue]="weightSelectedValue"></app-shared-popup-snapshot>


<app-shared-popup-snapshot *ngIf="isLoadSelection && !isDefaultLoad"
  [loadUserDefinedSavedScenarioData]="loadUserDefinedSavedScenarioData"
  [loadSharedWithMeSavedScenarioData]="loadSharedWithMeSavedScenarioData" [popUpParameter]="errorheaderTitle"
  [errorheaderTitle]="popUpTitle" [popUpMessage]="popUpMessage" [showInputPopUp]="false" [buttonText]="buttonText"
  [isChangeOfEntryPointConfigured]="true" (isLoadClickOutput)="onCloseIconClick($event)" [showErrorPopUp]="false"
  [showLoadSelection]="isLoadSelection" (ShareSelectionClick)="ShareSelection($event)"
  (currentSavedScenarioData)="bindcurrentSavedScenarioData($event)" (deleteMessage)="bindDeleteMessage($event)"
  (isShowDialog)="updateShowDialog($event)"
  (bindSelectedScenario)="bindSelectedScenario($event)"></app-shared-popup-snapshot>

<app-confirmation-dialog id="deleteConfirmation" *ngIf="isShowDialog" [messageText]="deleteMessage"
  (confirmed)="onConfirmation($event)"></app-confirmation-dialog>

<app-shared-popup-snapshot *ngIf="isShareSelectionClick" [shareSelectionUserList]="shareSelectionUserList"
  [showLoaderPopUp]="showLoaderPopUp" [selectedEmailsToShare]="selectedEmailsToShare"
  [selectedLoadSelectionObj]="selectedLoadSelectionObj" [isShareSelectionClick]="isShareSelectionClick"
  (isShareSelectionVisible)="handleShareSelectionPopUp($event)"
  (SaveSelectionClick)="SaveSelection($event)"></app-shared-popup-snapshot>

  <app-confirmation-dialog id="deleteConfirmation" *ngIf="isShowGlobalDefaultDialog" [messageText]="globalDefaultMessage"
  (confirmed)="onGlobalDefaultConfirmation($event)"></app-confirmation-dialog>

<!-- <app-shared-popup-snapshot *ngIf="isSaveSelectionClick" [showInputPopUp]="false" [showErrorPopUp]="false"
  [isSaveSelectionClick]="isSaveSelectionClick" [showLoaderPopUp]="showSaveSelectionPopup"
  [popUpParameter]="errorheaderTitle" (isSavePopUpVisible)="handleSavePopUP($event)"
  (SaveSelectionClick)="SaveSelection($event)"></app-shared-popup-snapshot> -->

<app-shared-popup-snapshot *ngIf="showErrorPopUp" [popUpParameter]="errorheaderTitle" [errorheaderTitle]="popUpTitle"
  [popUpMessage]="popUpMessage" [showInputPopUp]="false" [buttonText]="buttonText"
  (closeErrorPopUp)="onCloseIconClick($event)" [showErrorPopUp]="showErrorPopUp"></app-shared-popup-snapshot>

  <app-report-issue-popup *ngIf="isReportIssue" 
    [ClientName]="clientDetails.clientDetails.client_code" 
    [StudyName]="mainStudy" 
    [SnapshotName]="clientDetails.clientDetails.study" 
    [SelectedModule]="'SNAPSHOT'" 
    (closePopup)="isReportIssue = false"></app-report-issue-popup>

  <app-export-downloads-popup (closePopup)="showExportsDownloadsPopup = false" [showExportsDownloads]="showExportsDownloadsPopup"
  *ngIf="showExportsDownloadsPopup" [ReportInput]="exportReportInput" [ModuleName]="'Snapshot'"></app-export-downloads-popup>

  
  <app-shared-popup *ngIf="isDocumentRepositoryClick" [selected_study_name]="clientDetails.clientDetails.study"
      [selected_client_name]="selected_client" [docStorageData]="docStorageData"
      [loadSharedWithMeSavedScenarioData]="loadSharedWithMeSavedScenarioData" [showLoaderPopUp]="showLoaderPopUp"
      [isDocumentRepositoryClick]="isDocumentRepositoryClick"
      [isChangeOfEntryPointConfigured]="isChangeOfEntryPointConfigured"
      (bindSelectedScenario)="bindSelectedScenario($event)" (isShowDialog)="updateShowDialog($event)"
      (isDocClick)="updateDocClick($event)" (deleteMessage)="bindDeleteMessage($event)"
      (ShareSelectionClick)="ShareSelection($event)"
      (currentSavedScenarioData)="bindcurrentSavedScenarioData($event)"></app-shared-popup>

<app-shared-popup-snapshot *ngIf="BIPSelected" [widgetString]="widgetString" [BIPSelectedStatus] = "BIPSelected"></app-shared-popup-snapshot>

<app-shared-popup-snapshot *ngIf="this._configService.isFomChanged" [isFomChanged]="this._configService.isFomChanged"></app-shared-popup-snapshot>
